// extracted by mini-css-extract-plugin
export default {"container":"headerInfo_container__LDC0r","info":"headerInfo_info__K4Kos"};